// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"93fc0d3b","884":"c7e5ec24"}[chunkId] + ".chunk.js";
};